import store from 'store'

export default (context, inject) => {
    inject('localStore', store)
}